import React from 'react'
//import {useSelector} from 'react-redux' //remove
import ElementItem from './Modules/ElementItem4'
//import MyAccordion from '../../../../helpers/MyAccordion' //add new
import MyAccordion from './Modules/MyAccordion'
import { useEyeconxStore } from '../../../../store/eyeconxStore'
const ElementProperties = () => {
    const surveyElements = useEyeconxStore(state=>state.survey.data)
    //console.log(surveyElements)
    return ( 
        <>
        {surveyElements.length ===0 ? <div className="mt-3 mb-3 text-muted">Add Question to the survey.</div>:""}
        <MyAccordion>
             {surveyElements.length >0 &&
                    surveyElements.map((element,index)=>(
                        <ElementItem
                            key={index}
                            type={element.type}
                            element={element}
                            index={index}
                        />
                    ))

                  }
        </MyAccordion>
       
        <div>
       
        </div>
         
        </>
     );
}
 
export default ElementProperties;